import { Box, createStyles } from '@material-ui/core'
import { useOrgChart } from 'hooks'
import { FC } from 'react'
import ReactFlow, { Controls } from 'react-flow-renderer'
import { MyIdentityLayout, SubHeader } from 'components'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { PersonNode } from './PersonNode'
import { OrgChartSkeleton } from './OrgChartSkeleton'

const useStyles = makeStyles(
    createStyles({
        root: {
            marginTop: '65px',
            width: '100%',
            height: '90vh',
        },
    }),
)

export const nodeTypes = {
    person: PersonNode,
}

export const OrgChart: FC<{ personGuid: string }> = (props) => {
    const history = useHistory()

    const classes = useStyles()

    const { data, isLoading } = useOrgChart(props.personGuid)

    return (
        <MyIdentityLayout subHeader={<SubHeader showBackButtonOnly />}>
            {isLoading && (
                <Box className={classes.root}>
                    <OrgChartSkeleton />
                </Box>
            )}

            {data && (
                <Box className={classes.root}>
                    {/*@ts-ignore*/}

                    <ReactFlow
                        nodesDraggable={false}
                        nodesConnectable={false}
                        nodeTypes={nodeTypes}
                        elements={data}
                    >
                        <Controls
                            style={{
                                bottom: 'unset',
                                left: 'unset',
                                top: '32px',
                                right: '32px',
                            }}
                        />
                    </ReactFlow>
                </Box>
            )}
        </MyIdentityLayout>
    )
}
